import React from 'react'
import { StyledSpan } from './Lock.style'

const Lock = () => <StyledSpan />

export default Lock
